// Apply Nexa font to <html> element (similar to Next.js className={defaultFont.className})
// This runs before React mounts to avoid FOUC

const applyDefaultFont = () => {
  const html = document.documentElement
  html.style.fontFamily = '"Nexa", "Inter", ui-sans-serif, system-ui, sans-serif'
}

// Run immediately
applyDefaultFont()

export { applyDefaultFont }
